import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useCookieSettings, useTrackers, } from '../../useTrackers';
import { CookieBox } from './common';
import { DetailedCookies, } from './DetailedCookies';
import { OnlyNecessaryCookies, } from './OnlyNecessaryCookies';
import { SimpleCookies } from './SimpleCookies';
export const CookieConsent = ({ localizedStrings, isP2IAFullVersionUser, isP2iaPage, isUserInFrance, trackersParameters, zIndex, }) => {
    const [page, setPage] = useState('simple');
    const [enabledTracking, setEnabledTracking] = useCookieSettings();
    const trackers = useTrackers({
        isP2IAFullVersionUser,
        isP2iaPage,
        isUserInFrance,
        trackersParameters,
    });
    if (enabledTracking !== null) {
        return null;
    }
    if (isP2iaPage || isUserInFrance) {
        return (_jsx(CookieBox, Object.assign({ onClose: () => setEnabledTracking(false), localizedStrings: localizedStrings.cookieBox, zIndex: zIndex }, { children: _jsx(OnlyNecessaryCookies, { onAccept: () => setEnabledTracking(false), localizedStrings: localizedStrings.onlyNecessary }) })));
    }
    return (_jsx(CookieBox, Object.assign({ onClose: () => setEnabledTracking(true), localizedStrings: localizedStrings.cookieBox, zIndex: zIndex }, { children: page === 'simple' ? (_jsx(SimpleCookies, { onChoose: () => {
                setPage('detailed');
                trackers.event({
                    category: 'Cookies',
                    action: 'Show details',
                });
            }, onAccept: () => {
                setEnabledTracking(true);
                trackers.event({
                    category: 'Cookies',
                    action: 'Accept',
                });
            }, localizedStrings: localizedStrings.simpleCookies })) : (_jsx(DetailedCookies, { onSave: isPerformanceCookieSelected => {
                if (!isPerformanceCookieSelected) {
                    trackers.event({
                        category: 'Cookies',
                        action: 'Reject',
                    });
                }
                setEnabledTracking(isPerformanceCookieSelected);
            }, localizedStrings: localizedStrings.detailedCookies })) })));
};
//# sourceMappingURL=index.js.map